var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13208",
    "data-name": "Group 13208",
    transform: "translate(0 -0.374)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3860",
    "data-name": "Rectangle 3860",
    width: 24,
    height: 24,
    transform: "translate(0 0.374)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13167",
    "data-name": "Group 13167",
    transform: "translate(2 2.374)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42246",
    "data-name": "Path 42246",
    d: "M9.338,19.386c-.326-.048-.652-.088-.977-.144A9.327,9.327,0,0,1,3.4,16.736a9.44,9.44,0,0,1-2.867-5.5A9.557,9.557,0,0,1,7.029.68a9.392,9.392,0,0,1,8.8,1.486.38.38,0,0,1,.135.564.384.384,0,0,1-.591.038,8.674,8.674,0,0,0-3.831-1.677,8.6,8.6,0,0,0-5.752.948A8.459,8.459,0,0,0,1.471,7.585a8.613,8.613,0,0,0,2.535,8.694c.038.037.084.068.131.105a6.011,6.011,0,0,1,11.743,0A1.27,1.27,0,0,0,16,16.3a8.647,8.647,0,0,0,2.748-5.183A8.777,8.777,0,0,0,17.627,5.3a.672.672,0,0,1-.1-.347.332.332,0,0,1,.3-.308.344.344,0,0,1,.39.2c.289.6.6,1.191.842,1.809A7.949,7.949,0,0,1,19.567,9a.637.637,0,0,0,.034.123v1.349c-.024.165-.051.331-.071.5a9.347,9.347,0,0,1-2.237,5.069,9.4,9.4,0,0,1-5.594,3.2c-.336.061-.675.1-1.013.149Zm.682-.749a8.8,8.8,0,0,0,4.836-1.447c.37-.243.371-.242.268-.682a5.245,5.245,0,0,0-10.28.251.271.271,0,0,0,.135.307,8.85,8.85,0,0,0,5.041,1.572",
    transform: "translate(-0.415 -0.183)",
    fill: "#495584",
    stroke: "#495584",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42248",
    "data-name": "Path 42248",
    d: "M94.8,58.535a3.371,3.371,0,1,1-3.374,3.358A3.364,3.364,0,0,1,94.8,58.535m2.619,3.377a2.622,2.622,0,1,0-2.629,2.617,2.639,2.639,0,0,0,2.629-2.617",
    transform: "translate(-85.196 -54.542)",
    fill: "#495584",
    stroke: "#495584",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42249",
    "data-name": "Path 42249",
    d: "M236.339,45.4a.374.374,0,1,1-.368.383.368.368,0,0,1,.368-.383",
    transform: "translate(-219.854 -42.304)",
    fill: "#495584",
    stroke: "#495584",
    strokeWidth: 0.5
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.7f6d2078.svg";
export { ForwardRef as ReactComponent };